import React, {useState} from 'react';
import Switch from 'react-switch';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

export const TarjetaEncuestaRecurrente = (props) => {
	const {
		id,
		titulo,
		descripcion,
		frecuencia,
		estado,
		fechaCreaccion,
		elimiarEncuesta,
		cambiarEstadoEncuesta,
	} = props;

	const [ModalEliminarEncuesta, setModalEliminarEncuesta] = useState(false);

	return (
		<>
			<Modal
				centered={true}
				isOpen={ModalEliminarEncuesta}
				toggle={() => setModalEliminarEncuesta(!ModalEliminarEncuesta)}
			>
				<ModalHeader>
					<b>Eliminar encuesta</b>
				</ModalHeader>
				<ModalBody>
					<p>¿Está seguro que desea eliminar la encuesta?</p>
				</ModalBody>
				<ModalFooter>
					<div className='buttons-modal__EliminarEncuesta'>
						<div
							className='button'
							onClick={() => setModalEliminarEncuesta(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => {
								setModalEliminarEncuesta(false);
								elimiarEncuesta(id);
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<div className='encuesta-recurrente'>
				<div className='encuesta-recurrente__titulo'>{titulo}</div>
				<div className='separador'></div>
				<div className='encuesta-recurrente__descripcion'>{descripcion}</div>
				<div className='encuesta-recurrente__ffe'>
					<div className='encuesta-recurrente__fechaCreaccion'>
						<p>
							<b>Fecha de creación : </b>
							{fechaCreaccion}
						</p>
					</div>
					<div className='encuesta-recurrente__frecuencia'>
						<p>
							<b>Frecuencia con la que se realiza la encuesta: </b>
							{frecuencia}
						</p>
					</div>
					<div className='encuesta-recurrente__estado'>
						<div className='centrador'>
							<p>
								<b>Estado de la encuesta : </b>
							</p>
						</div>
						<div className='centrador'>
							<Switch
								checked={estado}
								onChange={() => cambiarEstadoEncuesta(id)}
							/>
						</div>
					</div>
				</div>
				<div
					className='encuesta-recurrente__borrar '
					onClick={() => setModalEliminarEncuesta(!ModalEliminarEncuesta)}
				>
					<div className='centrador'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='24'
							height='24'
							fill='currentColor'
							className='bi bi-trash'
							viewBox='0 0 16 16'
						>
							<path d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z' />
							<path
								fillRule='evenodd'
								d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'
							/>
						</svg>
					</div>
					<div>Eliminar</div>
				</div>
			</div>
		</>
	);
};
